import { ref } from "vue";

export const apiVersion = ref<string>("0.0.0.0");

export function useApiVersion() {
  return { apiVersion };
}
